import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers(['root', 'image']);

/**
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 *  keys: ("root" | "image")[]
 * }>} ImageStyles
 */
export const imageStyles = helpers.defineMultiStyleConfig({
  /**
   * @param {Object} args - Component arguments
   * @param {Contentful.Image} args.component - Image component data
   * @param {boolean} [args.isComplete] - Whether component has all fields
   * @param {boolean} [args.isFetching] - Whether additional data is being fetched
   *
   * @returns {ImageStyles} - Component styles
   */
  baseStyle({component}) {
    return {
      root: {
        textAlign: component.alignment ? component.alignment.toLowerCase() : undefined,
      },
      image: {
        display: 'inline-block',
      },
    };
  },
});
